/** localStorage キー定数（prefix: prosche.） */
export const LOCAL_STORAGE_KEYS = {
  USER_SETTINGS: 'prosche.userSettings',
  COLUMN_CONFIG: 'prosche.columnConfig',
  COLUMN_ORDER_CONFIG: 'prosche.columnOrderConfig',
  EDITABLE_COLUMN_CONFIG: 'prosche.editableColumnConfig',
  EDITABLE_COLUMN_ORDER_CONFIG: 'prosche.editableColumnOrderConfig',
  FILTER_CONFIG: 'prosche.filterConfig',
  FILTER_FIELD_ORDER_CONFIG: 'prosche.filterFieldOrderConfig',
  TAB_STATE: 'prosche.tabState',
  WORKBENCH_VIEW_STATE: 'prosche.workbenchViewState',
  ENABLED_FILTER_FIELDS: 'prosche.enabledFilterFields',
} as const;

export type LocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];
